import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flatlay%20of%20diverse%20fashion%20products%20including%20white%20sneakers%20beige%20hoodie%20denim%20jacket%20leather%20bag%20and%20gold%20accessories%20arranged%20artfully%20on%20warm%20cream%20linen%20background%20soft%20diffused%20overhead%20lighting%20casting%20gentle%20natural%20shadows%20clean%20minimalist%20editorial%20composition%20with%20intentional%20negative%20space%20around%20edges&width=1920&height=1080&seq=hero-main-v2&orientation=landscape"
          alt="AllChinaBuy Spreadsheet products"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-white/80 text-sm md:text-base font-medium tracking-wider uppercase mb-4">
            Updated Daily &bull; Verified Products &bull; Trusted Sellers
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            Best AllChinaBuy Spreadsheet
            <br />
            <span className="text-white/90">2026</span>
          </h1>
          <p className="text-white/75 text-sm md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover verified sellers, trending products, trusted links, and the latest AllChinaBuy spreadsheet resources in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-full sm:w-auto px-8 py-3.5 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-white/90 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
              AllChinaBuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div className="mt-10">
            <div className="relative inline-block">
              <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-medium rounded-full hover:bg-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap">
                <i className="ri-grid-line"></i>
                Browse Categories
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isDropdownOpen && (
                <>
                  <div className="fixed inset-0 z-40" onClick={() => setIsDropdownOpen(false)} />
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-80 bg-background-50 rounded-xl border border-background-200/70 py-2 z-50 max-h-[420px] overflow-y-auto text-left">
                    {categories.map((cat) => (
                      <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer" onClick={() => setIsDropdownOpen(false)}>
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-base text-primary-500`}></i>
                        </span>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-6 text-white/60 text-xs font-medium">
          <span className="flex items-center gap-1.5"><i className="ri-shield-check-line text-sm text-accent-400"></i>Verified</span>
          <span className="flex items-center gap-1.5"><i className="ri-time-line text-sm text-accent-400"></i>Updated Daily</span>
          <span className="flex items-center gap-1.5"><i className="ri-global-line text-sm text-accent-400"></i>International</span>
        </div>
      </div>
    </section>
  );
}